export default __webpack_public_path__ + "static/media/nftabout.0a93794b.png";